import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import ga from 'react-ga';

import 'babel-polyfill';

export const DEVICE_THRESHOLD = 960;
export const HEADER_HEIGHT = 360;
export const MENU_HEIGHT = 70;

ga.initialize(process.env.REACT_APP_GA_ID);
ga.pageview(window.location.pathname);

ReactDOM.render(
    <App />,
    document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js